document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.querySelector('.product-form__submit.button');

  addToCartButton.addEventListener('click', function handleClick(event) {
    console.log("Add to cart button clicked!");

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'add': {
          'products': [{
            'id': "shopify_DE_" + productDetails.id + '_' + productDetails.variantId,  // Concatenated product ID and variant ID
            'name': productDetails.title,
            'price': productDetails.price,
            'brand': productDetails.brand,
            'category': productDetails.category,
            'quantity': 1
          }]
        }
      }
    });
  });
});


